export const getQuarterIndex = (fyStartDate, currentDate) => {
    const startMonth = fyStartDate.getMonth();
    let currMonth = currentDate.getMonth();
    currMonth = currMonth < startMonth ? currMonth + 12 : currMonth;
    const diff = currMonth - startMonth;
    const quarter = Math.floor(diff / 3);
    return quarter;
};

export const hasAccelerateOrChallenger = user => {
    const hasIntegration = (user, ref) => {
        return user?.integrations && user.integrations.some(i => i.ref === ref);
    };

    return hasIntegration(user, 'CHALLENGER') || hasIntegration(user, 'ACCELERATE');
};
